// src/app/core/auth/auth-app-initializer.ts

import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';
import { AuthStateService } from './auth-state.service';

/**
 * Blocks app bootstrap until Firebase Auth has resolved its initial state
 * (logged in or logged out — either is fine, we just need to know which).
 *
 * Uses AuthStateService.isAuthReady rather than a raw onAuthStateChanged
 * subscription directly, so the same persistent listener that populates
 * currentUser / deauthReason also drives bootstrap readiness.
 */
export function provideAuthAppInitialiser(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const authState = inject(AuthStateService);

    return firstValueFrom(toObservable(authState.isAuthReady).pipe(filter((ready) => ready)));
  });
}
